/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type ShopsProductCategoriesListOrderByItem =
  (typeof ShopsProductCategoriesListOrderByItem)[keyof typeof ShopsProductCategoriesListOrderByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShopsProductCategoriesListOrderByItem = {
  '-id': '-id',
  '-series': '-series',
  id: 'id',
  series: 'series'
} as const
